import {observer} from "mobx-react";
import React from "react";
import {useBetween} from "use-between";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import ModalStartBackup from "@dropDesk/presentation/components/modals/modal_information";
import ModalDownloadBackup from "@dropDesk/presentation/components/modals/modal_information";
import {
    useModalBackup
} from "@dropDesk/presentation/pages/company_configurations/ui/backup/modals/handle_change_visible";
import {BackupData} from "@dropDesk/domain/entities/ticket/backup/backup_data";

const ModalsBackup = observer(
    ({
         loading,
         handleStartBackup,
         handleDownloadBackup
     }: {
        loading: boolean
        handleStartBackup: () => void
        handleDownloadBackup: (backupData: BackupData) => void
    }) => {

        const {
            visibleModalDownloadBackup, setVisibleModalDownloadBackup,
            visibleModalStartBackup, setVisibleModalStartBackup
        } = useBetween(useModalBackup);

        return (
            <>
                <ModalStartBackup
                    open={visibleModalStartBackup}
                    onRequestClose={() => {
                        setVisibleModalStartBackup(false);
                    }}
                    textHeaderModal={'Realizar backup'}
                    textButton={'OK'}
                    onRequestSave={() => {
                        handleStartBackup();
                        setVisibleModalStartBackup(false);
                    }}
                    nameIcon={ICONS_DROPDESK.info}
                    sizeIcon={130}
                    textInformation={`Atenção: O processo de backup pode levar até 48 horas para ser concluído. Para acessar o backup, utilize o e-mail principal da conta como senha.`}
                    loading={loading}
                />

                <ModalDownloadBackup
                    open={visibleModalDownloadBackup.visible}
                    onRequestClose={() => {
                        setVisibleModalDownloadBackup({visible: false, backupData: null});
                    }}
                    textHeaderModal={'Realizar download'}
                    textButton={'OK'}
                    onRequestSave={() => {
                        handleDownloadBackup(visibleModalDownloadBackup.backupData!);
                        setVisibleModalDownloadBackup({visible: false, backupData: null});
                    }}
                    nameIcon={ICONS_DROPDESK.info}
                    sizeIcon={130}
                    textInformation={`Atenção: Este backup contém todos os seus dados sensíveis. Certifique-se de armazená-lo em local seguro. Para garantir a segurança, a senha de acesso ao backup é o email da conta principal.`}
                    loading={loading}
                />

            </>
        )
    })
export default ModalsBackup;
